import { definePermisos } from '../utils'

export const RESOURCE_PRODUCCION_PG = 'Produccion PG'

export const permissionTree = definePermisos(RESOURCE_PRODUCCION_PG, 'produccionpg', {
    mantenimiento: {
        categoria: 'categoria',
        marca: 'marca',
        tipo_producto: 'tipo-producto',
        master: 'master',
        congelacion: 'congelacion',
        hidratacion: 'hidratacion',
        linea_producto: 'linea-producto',
        subtipo_producto: 'subtipo-producto',
        empaque: 'empaque',
        especie: 'especie',
        grupo_talla: 'grupo-talla',
        tipo_talla: 'tipo-talla',
        condicion: 'condicion',
        subcondicion: 'subcondicion',
        proceso: 'proceso',
        calidad: 'calidad',
        subproceso: 'subproceso',
        presentacion: 'presentacion',
        clasificacion: 'clasificacion',
        talla: 'talla',
        tratamiento: 'tratamiento',
        producto: 'producto',
        certificacion: 'certificacion',
    },
    transacciones: {
        orden_pedido: 'orden-pedido',
        orden_trabajo: 'orden-trabajo',
        bandeja_orden_trabajo: 'bandeja-orden-trabajo',
        costos: 'costos',
        aprobacion_producto: 'aprobacion-producto',
        aprobacion_op: 'aprobacion-op',
        solicitud_cambio_op: 'solicitud-cambio-op',
        aprobacion_op_sin_anticipo: 'aprobacion-op-sin-anticipo',
    },
    configuracion: {
        producto_base: 'producto-base',
        nivel_aprobacion_producto: 'nivel-aprobacion-producto',
        nivel_aprobacion_op: 'nivel-aprobacion-op',
        alerta_correo: 'alerta-correo',
        costo_proceso: 'costo-proceso',
    },
    informes: {
        consulta_orden_pedido: 'consulta-orden-pedido',
        bandeja_entrada_proformas: 'bandeja-entrada-proformas',
    },
})
// permissionTree._print()
